/**
 * Utility functions for Refgrow affiliate tracking
 */

/**
 * Get the Refgrow referral code from cookie
 * @returns The referral code if found, null otherwise
 */
export function getRefgrowReferralCode(): string | null {
  if (typeof document === 'undefined') return null;
  
  const cookies = document.cookie.split(';');
  const refgrowCookie = cookies.find(cookie => 
    cookie.trim().startsWith('refgrow_ref_code=')
  );
  
  if (refgrowCookie) {
    return refgrowCookie.split('=')[1]?.trim() || null;
  }
  
  return null;
}

/**
 * Track a Refgrow event (signup, purchase, etc.)
 * @param eventType Event type (0 for signup, 1 for purchase, etc.)
 * @param eventName Event name ('signup', 'purchase', etc.)
 * @param userEmail User's email address
 */
export function trackRefgrowEvent(eventType: number, eventName: string, userEmail: string): void {
  try {
    if (typeof window !== 'undefined' && (window as any).Refgrow && typeof (window as any).Refgrow === 'function') {
      (window as any).Refgrow(eventType, eventName, userEmail);
      console.log(`[Refgrow] Tracked event: ${eventName} for ${userEmail}`);
    } else {
      console.log(`[Refgrow] Refgrow not available, skipping event: ${eventName} for ${userEmail}`);
    }
  } catch (error) {
    console.error('[Refgrow] Error tracking event:', error);
  }
}